import { ActionTypes } from "../constants";

const reduceTerms = (state = null, action) => {
    switch (action.type) {

        case ActionTypes.GET_TERMS_SUCCESS:
            return action.data || [];

        case ActionTypes.UPDATE_TERM_SUCCESS:
            return [
                ...state.filter(({uuid}) => Number(uuid) !== Number(action.payload.id)),
                {
                    ...state.find(({uuid}) => uuid === action.payload.id),
                    ...action.payload.params
                }
            ];

        case ActionTypes.LOGOUT:
            return null;

        default:
            return state;
    }
};

export default reduceTerms;
